import React from 'react';
import { motion } from 'framer-motion';
import { useLanguage } from '../contexts/LanguageContext';
import './Contact.css';

const Contact = () => {
  // All state and handler functions are removed as they are no longer needed.
  const { t } = useLanguage();

  const adminEmail = "info@anandmaya.net";
  const subject = t('home.contact.mailSubject');
  
  // Construct the mailto link
  const mailtoLink = `mailto:${adminEmail}?subject=${encodeURIComponent(subject)}`;

  return (
    <section id="contact" className="contact">
      <div className="container">
        <div className="section-header">
          <h2>{t('home.contact.getInTouch')}</h2>
          <p>{t('home.contact.subtitle')}</p>
        </div>
        <div className="contact-content">
          <motion.div
            className="contact-info"
            initial={{ opacity: 0, x: -50 }}
            whileInView={{ opacity: 1, x: 0 }}
            transition={{ duration: 0.8 }}
            viewport={{ once: true }}
          >
            {/* The contact info details on the left side remain unchanged */}
            <div className="contact-item">
              <i className="fas fa-map-marker-alt"></i>
              <div>
                <h4>{t('home.contact.address')}</h4>
                <p>{t('home.contact.addressLine1')} <br />{t('home.contact.addressLine2')}</p>
              </div>
            </div>
            <div className="contact-item">
              <i className="fas fa-phone"></i>
              <div>
                <h4>{t('home.contact.phone')}</h4>
                <p>+91-7790094555 </p>
              </div>
            </div>
            <div className="contact-item">
              <i className="fas fa-envelope"></i>
              <div>
                <h4>{t('home.contact.email')}</h4>
                <p>{adminEmail}</p>
              </div>
            </div>
          </motion.div>

          {/* --- THIS IS THE UPDATED FORM SECTION --- */}
          <motion.div
            className="contact-form" // We keep the class for styling
            initial={{ opacity: 0, x: 50 }}
            whileInView={{ opacity: 1, x: 0 }}
            transition={{ duration: 0.8 }}
            viewport={{ once: true }}
          >
            {/* The input fields are removed as they are no longer functional */}
            <p className="contact-prompt">
              {t('home.contact.prompt')}
            </p>
            
            <motion.a
              href={mailtoLink} // The href now points to the mailto link
              className="btn btn-primary"
              whileHover={{ scale: 1.05 }}
              whileTap={{ scale: 0.98 }}
            >
              {t('home.contact.sendEmail')}
            </motion.a>
          </motion.div>
          {/* ------------------------------------- */}

        </div>
      </div>
    </section>
  );
};

export default Contact;
